<button class="topmenu__btn" type="button" data-id="open" aria-label="<%= _lcs( 'Menü öffnen' ) %>" aria-haspopup="dialog">
  <i class="icon icon--menu topmenu__icon"></i>
</button>
